// ---------------------import---------------------------
import { initialModalState } from './unimodal';
import { getWSLSKey } from '../customLib';
import { initialSubmittedDetails, initialUserName } from './profile';
import { initCoins } from './coins';
import {
	initialWalletBal,
	// initialRefWallet,
	initialCryptoBal,
} from './balances';
import {
	initialSideNotifs,
	initialUserAlerts,
	initialActionsRequired,
} from './notifications';
import { initialContestData } from './contest';
import { initialSelectStatus } from './select';
import { initDiwaliThingies } from './customStuffs/diwali';
import { initialDisabledThingies } from './disabledThingies';
import { initialMonitorState } from './monitor';
import { initialTradeOrders } from './tradeOrders';
import { initialWithList } from './withdrawalQueue';
import { initTabFocus, initOnlineCheck } from './browserEvents';
import { initialCountryState } from './country';
import { initialCurrencyState } from './currency';
import { initialSafetyShown } from './safetyChecklist';
import { initialNewUser } from './checkNewUser';
import { initialConvRates } from './convRates';
// import { initialP2PUSD } from './p2p/usdt';
// import { initNewHighlight } from './highlight';

// ---------------------export---------------------------

export { convRatesActions } from './convRates';
export { redirectURLActions } from './redirectURL';
export { gaEventActions } from './gaEvent';
export { loginActions } from './loginStuffs';
export { modalActions } from './unimodal';
export { profileActions } from './profile';
export { coinsActions } from './coins';
export { balanceActions } from './balances';
export { contestActions } from './contest';
export { selectStatusActions } from './select';
export { diwaliActions } from './customStuffs/diwali';
export { disabledThingiesActions } from './disabledThingies';
export { monitorActions } from './monitor';
export { dashboardActions } from './tradeOrders';
export { getP2pBankWithListActions } from './withdrawalQueue';
export { newUserActions } from './checkNewUser';
export {
	sidebarActions,
	userAlertActions,
	actionsRequiredActions,
} from './notifications';
export { tabFocusActions, onlineCheckActions } from './browserEvents';
export { tickerActions } from './rates';
export { countryActions } from './country';
export { currencyActions } from './currency';
export { safetyChecklistActions } from './safetyChecklist';
// export { P2PUSDTActions } from './p2p/usdt';
// export {  highlightActions } from './highlight';

// initialState of store

export const initialState = {
	selectedMarket: 1,
	currentRate: {},
	lastRateUpdated: Date.now(),
	checkingLogin: false,
	cryptoBal: initialCryptoBal,
	disabledThingies: initialDisabledThingies,
	// refWallet: initialRefWallet,
	refStats: {
		count: 0,
		last20: [],
	},
	isBankAvailable: 0,
	isLoggedIn: +getWSLSKey('bb-isLoggedIn') || 0,
	isNotFlagged: true,
	isVerified: 2,
	kaatLe: 1,
	lastBalChecked: null,
	referralID: null,
	refLink: '...',
	submittedDetails: initialSubmittedDetails,
	switchMarketModal: false,
	switchMarketCoin: {
		coin: 'btc',
		market_id: 0,
	},
	usdtRate: 0,
	walletBal: initialWalletBal,
	urlLocation: '/',
	redirectURLLocation: '/',
	...initCoins,
	...initialModalState,
	...initialSelectStatus,
	...initDiwaliThingies,
	...initialMonitorState,
	...initialTradeOrders,
	...initialSideNotifs,
	...initialContestData,
	...initialWithList,
	...initialUserAlerts,
	...initialUserName,
	...initTabFocus,
	...initOnlineCheck,
	...initialActionsRequired,
	...initialCountryState,
	...initialSafetyShown,
	...initialCurrencyState,
	...initialNewUser,
	...initialConvRates,
};

// combines actions to form object of only required actions

export const actionsCombiner = function (...args) {
	const actionArgs = args;

	return store => {
		let combinedArgs = {};

		if (actionArgs.length > 0) {
			actionArgs.forEach(action => {
				if (typeof action === 'function') {
					combinedArgs = {
						...combinedArgs,
						...action(store),
					};
				}
				if (typeof action === 'object') {
					combinedArgs = {
						...combinedArgs,
						...action,
					};
				}
			});
		}

		return combinedArgs;
	};
};
